'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Images = function (_Component) {
  _inherits(Images, _Component);

  function Images() {
    _classCallCheck(this, Images);

    return _possibleConstructorReturn(this, (Images.__proto__ || Object.getPrototypeOf(Images)).apply(this, arguments));
  }

  _createClass(Images, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          related = _props.related,
          link = _props.link,
          bordered = _props.bordered,
          rounded = _props.rounded,
          circular = _props.circular,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['related', 'link', 'bordered', 'rounded', 'circular', 'className']);

      var cx = (0, _classnames2.default)({
        related: related,
        link: link,
        bordered: bordered,
        rounded: rounded,
        circular: circular
      }, 'images', className);

      return _react2.default.createElement(_Box2.default, _extends({
        ts: true,
        className: cx
      }, rest));
    }
  }]);

  return Images;
}(_react.Component);

Images.displayName = 'Images';

Images.propTypes = {
  related: _propTypes2.default.bool,
  link: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  rounded: _propTypes2.default.bool,
  circular: _propTypes2.default.bool
};

exports.default = Images;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkltYWdlcy5qcyJdLCJuYW1lcyI6WyJJbWFnZXMiLCJwcm9wcyIsInJlbGF0ZWQiLCJsaW5rIiwiYm9yZGVyZWQiLCJyb3VuZGVkIiwiY2lyY3VsYXIiLCJjbGFzc05hbWUiLCJyZXN0IiwiY3giLCJkaXNwbGF5TmFtZSIsInByb3BUeXBlcyIsImJvb2wiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7Ozs7Ozs7SUFFTUEsTTs7Ozs7Ozs7Ozs7NkJBQ0s7QUFBQSxtQkFTSCxLQUFLQyxLQVRGO0FBQUEsVUFFTEMsT0FGSyxVQUVMQSxPQUZLO0FBQUEsVUFHTEMsSUFISyxVQUdMQSxJQUhLO0FBQUEsVUFJTEMsUUFKSyxVQUlMQSxRQUpLO0FBQUEsVUFLTEMsT0FMSyxVQUtMQSxPQUxLO0FBQUEsVUFNTEMsUUFOSyxVQU1MQSxRQU5LO0FBQUEsVUFPTEMsU0FQSyxVQU9MQSxTQVBLO0FBQUEsVUFRRkMsSUFSRTs7QUFVUCxVQUFJQyxLQUFLLDBCQUNQO0FBQ0VQLHdCQURGO0FBRUVDLGtCQUZGO0FBR0VDLDBCQUhGO0FBSUVDLHdCQUpGO0FBS0VDO0FBTEYsT0FETyxFQVFQLFFBUk8sRUFTUEMsU0FUTyxDQUFUOztBQVlBLGFBQ0U7QUFDRSxnQkFERjtBQUVFLG1CQUFXRTtBQUZiLFNBR01ELElBSE4sRUFERjtBQU9EOzs7Ozs7QUFHSFIsT0FBT1UsV0FBUCxHQUFxQixRQUFyQjs7QUFFQVYsT0FBT1csU0FBUCxHQUFtQjtBQUNqQlQsV0FBUyxvQkFBVVUsSUFERjtBQUVqQlQsUUFBTSxvQkFBVVMsSUFGQztBQUdqQlIsWUFBVSxvQkFBVVEsSUFISDtBQUlqQlAsV0FBUyxvQkFBVU8sSUFKRjtBQUtqQk4sWUFBVSxvQkFBVU07QUFMSCxDQUFuQjs7a0JBUWVaLE0iLCJmaWxlIjoiSW1hZ2VzLmpzIiwic291cmNlUm9vdCI6IkQ6XFxQcm9qZWN0c1xccmVhY3QtdG9jYXNcXHNyYyJ9



//////////////////
// WEBPACK FOOTER
// ../lib/Images.js
// module id = 571
// module chunks = 0